import { render, staticRenderFns } from "./order-form-property-base-color.vue?vue&type=template&id=01da0764&scoped=true"
import script from "./order-form-property-base-color.vue?vue&type=script&lang=js"
export * from "./order-form-property-base-color.vue?vue&type=script&lang=js"
import style0 from "./order-form-property-base-color.vue?vue&type=style&index=0&id=01da0764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01da0764",
  null
  
)

export default component.exports